import { Component, Input } from '@angular/core';

@Component({
    selector: 'cs-sort-icons',
    templateUrl: 'sort-icons.component.html'
})

export class CustomSortIconsComponent {
    @Input() sortAscending: boolean; 
}